import { render, staticRenderFns } from "./CardSidebar.vue?vue&type=template&id=ae56eac8&scoped=true&"
import script from "./CardSidebar.vue?vue&type=script&lang=js&"
export * from "./CardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CardSidebar.vue?vue&type=style&index=0&id=ae56eac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae56eac8",
  null
  
)

export default component.exports